import { apiConfig } from '../config/api';
import { Slide, SlideSummary, AnalysisTask } from '../types';

class AnalysisService {
  async getSlide(deckId: string, slideNumber: number, token: string): Promise<Slide> {
    const response = await fetch(
      `${apiConfig.baseUrl}${apiConfig.endpoints.slide(deckId, slideNumber)}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch slide');
    }

    const data = await response.json();
    return data.data.slide;
  }

  async getSlides(deckId: string, token: string, status?: string): Promise<SlideSummary[]> {
    const url = status
      ? `${apiConfig.baseUrl}${apiConfig.endpoints.slides(deckId)}?status=${status}`
      : `${apiConfig.baseUrl}${apiConfig.endpoints.slides(deckId)}`;

    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch slides');
    }

    const data = await response.json();
    return data.data.slides;
  }

  async getTasks(token: string): Promise<AnalysisTask[]> {
    const response = await fetch(`${apiConfig.baseUrl}${apiConfig.endpoints.tasks}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch tasks');
    }

    const data = await response.json();
    return data.data.tasks;
  }

  async getDefaultPrompts(token: string): Promise<Record<string, string>> {
    const response = await fetch(`${apiConfig.baseUrl}${apiConfig.endpoints.defaultPrompts}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch default prompts');
    }

    const data = await response.json();
    return data.data.prompts as Record<string, string>;
  }

  async setFindingAddressed(
    deckId: string,
    slideNumber: number,
    findingId: string,
    addressed: boolean,
    token: string
  ): Promise<void> {
    const response = await fetch(
      `${apiConfig.baseUrl}${apiConfig.endpoints.updateFindingAddressed(deckId, slideNumber)}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ findingId, addressed }),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update finding status');
    }
  }

  async setFindingIgnored(
    deckId: string,
    slideNumber: number,
    findingId: string,
    ignored: boolean,
    token: string
  ): Promise<void> {
    const response = await fetch(
      `${apiConfig.baseUrl}${apiConfig.endpoints.updateFindingAddressed(deckId, slideNumber)}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ findingId, ignored }),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update finding status');
    }
  }
}

export const analysisService = new AnalysisService();
export default AnalysisService;

